/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusPrivacyPolicyDetailDto } from '../../models/lexplus-privacy-policy-detail-dto';

export interface PrivacyPolicyControllerFindOneV1$Params {
  id: number;
}

export function privacyPolicyControllerFindOneV1(http: HttpClient, rootUrl: string, params: PrivacyPolicyControllerFindOneV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusPrivacyPolicyDetailDto>> {
  const rb = new RequestBuilder(rootUrl, privacyPolicyControllerFindOneV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusPrivacyPolicyDetailDto>;
    })
  );
}

privacyPolicyControllerFindOneV1.PATH = '/v1/privacy-policies/{id}';
